<template>
  <v-layout
    v-bind="attributes"
    @contextmenu="selectComponentDEV($event, schema.model)"
    :class="['fab-container', getSelectedDEV && 'dev-selected-component']"
  >
    <template v-for="(action, index) in actions">
      <v-tooltip left :color="action.tooltipColorClass" :key="index" :disabled="!action.tooltip">
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            :data-has-tooltip="action.tooltip ? 'true' : 'false'"
            :data-tooltip="action.tooltip"
            v-on="on"
            fab
            v-bind="[action.attributes, attrs]"
            @click="execute(action)"
            :key="index"
            :name="action.name"
            :id="action.id"
          >
            <v-icon v-if="action.attributesIcon.icon" v-bind="action.attributesIcon">{{
              action.attributesIcon.icon
            }}</v-icon>
          </v-btn>
        </template>
        <span>{{ action.tooltip }}</span>
      </v-tooltip>
    </template>
  </v-layout>
</template>

<script>
import * as HANDLERS from '@/helpers/types/handlers';
import devComponentMixin from '@/mixins/dev-component-mixin';
import actionDefault from '@/mixins/action-default';

export default {
  mixins: [devComponentMixin, actionDefault],

  props: {
    actions: { type: Array, required: true },
    mode: { type: String, required: true },
    page: { type: String, required: true },
    step: { type: Number, required: false },
    attributes: { type: Object, default: () => ({}), required: true },
    schema: { type: Object, default: () => ({}) }
  },

  events: {
    [HANDLERS.ACTION_DEFAULT]: 'executeActionDefault'
  },

  methods: {
    execute(action) {
      action.mode = this.mode;

      this.$emit(HANDLERS.EXECUTE_ACTION, { action, origin: this.page, step: this.step });
    }
  }
};
</script>

<style lang="scss" scoped>
.fab-container {
  position: fixed;
  bottom: 10px;
  right: 10px;
  z-index: 5;
}

.v-card__actions .v-btn {
  margin: 6px 8px;
}
</style>
